/**
 * Whether the Yandex Maps integration is available in this build.
 *
 * Coordinates can only be produced by the address suggester or the map
 * picker, and both need this key — the Dockerfile defaults its ARG to empty,
 * so a build whose CI secret is missing ships without it. Any rule that
 * *requires* coordinates has to be conditional on this flag, or a keyless
 * build cannot create or edit a property at all: the address field would
 * reject every value while the only two components that could satisfy it
 * refuse to load.
 */
export const YANDEX_MAPS_API_KEY = import.meta.env.VITE_YANDEX_MAPS_API_KEY as string | undefined

export const IS_MAPS_CONFIGURED = !!YANDEX_MAPS_API_KEY
